import { render, staticRenderFns } from "./JobAlert.html?vue&type=template&id=560c7e10&%3Akey=componentKey&"
import script from "./JobAlertPage.vue?vue&type=script&lang=ts&"
export * from "./JobAlertPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports